var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "批次名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.batchName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "batchName", $$v)
                      },
                      expression: "searchInfo.batchName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发送状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.batchStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "batchStatus", $$v)
                        },
                        expression: "searchInfo.batchStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "未发送", value: 1 } },
                        [_vm._v("未发送")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "发送中", value: 2 } },
                        [_vm._v("发送中")]
                      ),
                      _c(
                        "el-option",
                        { key: 3, attrs: { label: "发送完成", value: 3 } },
                        [_vm._v("发送完成")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.onAdd }
                    },
                    [_vm._v("新增批量送券")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "批次编号", prop: "batchNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "批次名称", prop: "batchName" }
          }),
          _c("el-table-column", {
            attrs: { label: "发送总人数", prop: "giveNum", width: "100px" }
          }),
          _c("el-table-column", {
            attrs: { label: "发送成功人数", prop: "succussNum", width: "110px" }
          }),
          _c("el-table-column", {
            attrs: { label: "发送失败人数", prop: "errorNum", width: "110px" }
          }),
          _c("el-table-column", {
            attrs: { label: "发券原因", prop: "remark" }
          }),
          _c("el-table-column", {
            attrs: { label: "开始发送时间", prop: "startTime" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.startTime)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "发送结束时间", prop: "endTime" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.endTime)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "batchStatus", width: "93px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.batchStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", effect: "plain" } },
                          [_vm._v("未发送")]
                        )
                      : _vm._e(),
                    scope.row.batchStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warn", effect: "plain" } },
                          [_vm._v("发送中")]
                        )
                      : _vm._e(),
                    scope.row.batchStatus == 3
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("发送完成")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "300px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onViewTicket(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看优惠券")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onExportError(scope.row)
                          }
                        }
                      },
                      [_vm._v("导出失败数据")]
                    ),
                    scope.row.errorNum > 0 &&
                    [1, 2].includes(scope.row.userType)
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onReSend(scope.row)
                              }
                            }
                          },
                          [_vm._v("重新发送")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-send-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "批次名称：",
                                    prop: "batchName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.batchName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "batchName", $$v)
                                      },
                                      expression: "formData.batchName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "用户选择：",
                                    prop: "userType"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      on: { change: _vm.onChangeUserType },
                                      model: {
                                        value: _vm.formData.userType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "userType",
                                            $$v
                                          )
                                        },
                                        expression: "formData.userType"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("输入手机")
                                      ]),
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("导入会员UID excel")
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("导入手机号excel")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      [1, 2].includes(_vm.formData.userType)
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "" } },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          attrs: {
                                            name: "batchFile",
                                            action:
                                              _vm.path +
                                              "/ticket/batch/give/tickets",
                                            headers: { "x-token": _vm.token },
                                            data: _vm.formData,
                                            "auto-upload": false,
                                            limit: 1,
                                            "file-list": _vm.fileList,
                                            accept: ".xlsx,.xls",
                                            "before-upload": _vm.uploadBefore,
                                            "on-success": _vm.onUploadSuccess,
                                            "on-error": _vm.onUploadError
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "primary"
                                              }
                                            },
                                            [_vm._v("点击上传")]
                                          ),
                                          _c("div", {
                                            staticClass: "el-upload__tip",
                                            attrs: { slot: "tip" },
                                            slot: "tip"
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _c("div", { staticStyle: { color: "red" } }, [
                                  _c("div", [_vm._v("注意：")]),
                                  _c("div", [
                                    _vm._v("1、只能上传xlsx/xls文件")
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "2、excel数据注意要先去重处理，点击excel【数据】->【删除重复值】"
                                    )
                                  ])
                                ])
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      [3].includes(_vm.formData.userType)
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "手机号：",
                                        prop: "userPhones"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder:
                                            "请输入,多个手机号用英文逗号分割",
                                          rows: 5
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.formData.userPhones,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "userPhones",
                                              $$v
                                            )
                                          },
                                          expression: "formData.userPhones"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "发券原因：", prop: "remark" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入",
                                      rows: 5
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.remark,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "remark", $$v)
                                      },
                                      expression: "formData.remark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "赠送券：" }
                                },
                                _vm._l(
                                  _vm.formData.giveticketRulesList,
                                  function(item, index) {
                                    return _c(
                                      "el-row",
                                      { staticClass: "ticket-form-item" },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "券编号",
                                                  prop:
                                                    "giveticketRulesList." +
                                                    index +
                                                    ".ticketRuleNo"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "输入券编号"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.getTicketDetail(
                                                        item
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: item.ticketRuleNo,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ticketRuleNo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.ticketRuleNo"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "数量",
                                                  prop:
                                                    "giveticketRulesList." +
                                                    index +
                                                    ".num"
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请输入张数",
                                                    min: 1
                                                  },
                                                  model: {
                                                    value: item.num,
                                                    callback: function($$v) {
                                                      _vm.$set(item, "num", $$v)
                                                    },
                                                    expression: "item.num"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "bairun-form-item-label-suffix"
                                                  },
                                                  [_vm._v("张")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          {
                                            staticClass: "btn-tool-balancrange",
                                            attrs: { span: 2 }
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onDeleteTicket(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("-")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          {
                                            staticClass: "btn-tool-balancrange",
                                            attrs: { span: 2 }
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onAddTicket(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("+")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 1 } }, [_vm._v(" ")]),
              _c("el-col", { attrs: { span: 8 } }, [
                _vm.formData.userType == 1
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "font-size": "20px",
                            "font-weight": "bold"
                          }
                        },
                        [_vm._v("导入会员UID excel模板参考")]
                      ),
                      _c("img", {
                        staticStyle: {
                          width: "300px",
                          display: "block",
                          margin: "auto",
                          "margin-top": "20px"
                        },
                        attrs: {
                          src: require("@/assets/ticketSendUidTpl.png"),
                          alt: ""
                        }
                      })
                    ])
                  : _vm._e(),
                _vm.formData.userType == 2
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "font-size": "20px",
                            "font-weight": "bold"
                          }
                        },
                        [_vm._v("导入手机号excel模板参考")]
                      ),
                      _c("img", {
                        staticStyle: {
                          width: "300px",
                          display: "block",
                          margin: "auto",
                          "margin-top": "20px"
                        },
                        attrs: {
                          src: require("@/assets/ticketSendMobileTpl.png"),
                          alt: ""
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("马上发送")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.reSendDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-send-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.reSendDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _vm.formData.batchNo != ""
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "批次编号：",
                                        prop: "batchNo"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: true },
                                        model: {
                                          value: _vm.formData.batchNo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "batchNo",
                                              $$v
                                            )
                                          },
                                          expression: "formData.batchNo"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "批次名称：",
                                    prop: "batchName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: true },
                                    model: {
                                      value: _vm.formData.batchName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "batchName", $$v)
                                      },
                                      expression: "formData.batchName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "用户选择：",
                                    prop: "userType"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.userType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "userType",
                                            $$v
                                          )
                                        },
                                        expression: "formData.userType"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("导入会员UID excel")
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("导入手机号excel")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "重新上传文件：" }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "upload",
                                      attrs: {
                                        name: "batchFile",
                                        action:
                                          _vm.path +
                                          "/ticket/batch/give/tickets",
                                        headers: { "x-token": _vm.token },
                                        data: _vm.formData,
                                        "auto-upload": false,
                                        limit: 1,
                                        "file-list": _vm.fileList,
                                        accept: ".xlsx,.xls",
                                        "before-upload": _vm.uploadBefore,
                                        "on-success": _vm.onUploadSuccess,
                                        "on-error": _vm.onUploadError
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary"
                                          }
                                        },
                                        [_vm._v("点击上传")]
                                      ),
                                      _c("div", {
                                        staticClass: "el-upload__tip",
                                        attrs: { slot: "tip" },
                                        slot: "tip"
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticStyle: { color: "red" } }, [
                              _c("div", [
                                _vm._v(
                                  "注意：请重新上传上次发送的文件，已发送成功的系统会自动过滤，未发送成功的系统将再次发送"
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 1 } }, [_vm._v(" ")]),
              _c("el-col", { attrs: { span: 8 } }, [
                _vm.formData.userType == 1
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "font-size": "20px",
                            "font-weight": "bold"
                          }
                        },
                        [_vm._v("导入会员UID excel模板参考")]
                      ),
                      _c("img", {
                        staticStyle: {
                          width: "300px",
                          display: "block",
                          margin: "auto",
                          "margin-top": "20px"
                        },
                        attrs: {
                          src: require("@/assets/ticketSendUidTpl.png"),
                          alt: ""
                        }
                      })
                    ])
                  : _vm._e(),
                _vm.formData.userType == 2
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "font-size": "20px",
                            "font-weight": "bold"
                          }
                        },
                        [_vm._v("导入手机号excel模板参考")]
                      ),
                      _c("img", {
                        staticStyle: {
                          width: "300px",
                          display: "block",
                          margin: "auto",
                          "margin-top": "20px"
                        },
                        attrs: {
                          src: require("@/assets/ticketSendMobileTpl.png"),
                          alt: ""
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("马上重新发送")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.ticketDialogVisible,
            title: _vm.dialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.ticketDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.ticketRulesList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "券编号",
                                      prop: "ticketRuleNo"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "优惠券名称",
                                      prop: "ticketName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "张数", prop: "num" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }